import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { consultar } from '@/api/creditoInformado'

export default async function avisarCreditoInformadoDoCliente(cnpjOuCpfCliente: string, lojaId: string): Promise<void> {
	if (!cnpjOuCpfCliente || !lojaId) return

	let resposta
	try {
		resposta = await consultar(cnpjOuCpfCliente, lojaId)
	} catch {
		return
	}

	if (!resposta.integracaoConfigurada) return

	if (resposta.bloqueado) {
		AlertModule.setError(
			`Cliente bloqueado${resposta.motivosBloqueio.length ? ': ' + resposta.motivosBloqueio.join(', ') : ''}`,
		)
	} else if (resposta.consultaIndisponivel) {
		AlertModule.setWarning('Não foi possível confirmar o crédito do cliente agora. A consulta está indisponível.')
	}
}
